import { render, staticRenderFns } from "./DynamicFormContent.vue?vue&type=template&id=766f8c1b&scoped=true"
import script from "./DynamicFormContent.vue?vue&type=script&lang=js"
export * from "./DynamicFormContent.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormContent.vue?vue&type=style&index=0&id=766f8c1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f8c1b",
  null
  
)

export default component.exports